// Development
// export const API_BASE_URL = 'https://dev.caredac.com'

// Production
export const API_BASE_URL = 'https://api.caredac.com'
// export const API_BASE_URL = 'http://localhost:8080';

// Development
// export const MEDIA_URL = "https://d28qzefaa2n2nh.cloudfront.net";

// Production
export const MEDIA_URL = "https://dlhgrltgo56b6.cloudfront.net";

export const ApiEndPoints = {
  AUTH: {
    login: `${API_BASE_URL}/api/v1/admin/login`,
    me: `${API_BASE_URL}/api/v1/admin/profile`,
    forgot: `${API_BASE_URL}/api/v1/auth/forgot-password`,
    verifyotp: `${API_BASE_URL}/api/v1/auth/verify-otp-admin`,
    reset: `${API_BASE_URL}/api/v1/auth/reset-password-admin`
  },

  USERS_COUNTS: {
    getcount: `${API_BASE_URL}/api/v1/admin/dashboard`,
  },
  PATIENT_LIST: {
    getpatient: `${API_BASE_URL}/api/v1/admin/user`,
    getpatientbyid: (id) => `${API_BASE_URL}/api/v1/admin/user/${id}`,
    deletepatient: (id) => `${API_BASE_URL}/api/v1/admin/user/${id}`,
    patientappintment: (id) => `${API_BASE_URL}/api/v1/admin/appointment-list/${id}`
  },
  CAREGIVER_LIST: {
    addCaregiver: `${API_BASE_URL}/api/v1/admin/caregiver-registration`,
    editCaregiver: (id) => `${API_BASE_URL}/api/v1/admin/caregiver/${id}`,
    caregiverslot: (id) => `${API_BASE_URL}/api/v1/admin/availability/caregiver/${id}`,
    verifyDoc: (id) => `${API_BASE_URL}/api/v1/admin/verify-doc/caregiver/${id}`,
    unavailabilityslot: (id) => `${API_BASE_URL}/api/v1/admin/unavailability/caregiver/${id}`,
    languagespeak: `${API_BASE_URL}/api/v1/common/language-speak`,
    addlanguagespeak: `${API_BASE_URL}/api/v1/admin/language-speak`,
    deletelanguagespeak: (id) => `${API_BASE_URL}/api/v1/admin/language-speak/${id}`,
    getcaregiver: `${API_BASE_URL}/api/v1/admin/caregivers`,
    getcaregiverbyid: (id) => `${API_BASE_URL}/api/v1/admin/user/${id}`,
    changeStatus: (id) => `${API_BASE_URL}/api/v1/admin/account-status/user/${id}`,
    changeBackgroundStatus: (id) => `${API_BASE_URL}/api/v1/admin/background-status/caregiver/${id}`,
  },
  Appointment: {
    // getappointment: `${API_BASE_URL}/api/v1/admin/appointment`,
    getappointment: `${API_BASE_URL}/api/v1/admin/appointment`,
    getappointmentbyid: (id) => `${API_BASE_URL}/api/v1/admin/appointment/${id}`,
    editappointment: (id) => `${API_BASE_URL}/api/v1/admin/appointment/${id}`,
  },
  SERVICE_COST: {
    getservice: `${API_BASE_URL}/api/v1/admin/services-cost`,
    addservice: `${API_BASE_URL}/api/v1/admin/services-cost`,
    editservice: `${API_BASE_URL}/api/v1/admin/services-cost`
  },
  GUIDELINES: {
    getguidelines: `${API_BASE_URL}/api/v1/admin/guidelines`,
    editservice: `${API_BASE_URL}/api/v1/admin/guidelines`
  },
  POLICIES: {
    getpolicies: `${API_BASE_URL}/api/v1/admin/policies`,
    editpolicies: `${API_BASE_URL}/api/v1/admin/policies`
  },
  TERMS: {
    getterms: `${API_BASE_URL}/api/v1/admin/terms`,
    editterms: `${API_BASE_URL}/api/v1/admin/terms`
  },
  TRUST_SAFETY: {
    gettrust: `${API_BASE_URL}/api/v1/admin/trust-safety`,
    edittrust: `${API_BASE_URL}/api/v1/admin/trust-safety`
  },
  HOLIDAY: {
    getholidays: `${API_BASE_URL}/api/v1/admin/holiday`,
    addholidays: `${API_BASE_URL}/api/v1/admin/holiday`,
    deleteholidays: (id) => `${API_BASE_URL}/api/v1/admin/holiday/${id}`
  },
  PAYOUT_SCHEDULE: {
    update: `${API_BASE_URL}/api/v1/admin/payout-schedule`
  },
  CAREGIVER_STRIPE: {
    onboardingLink: `${API_BASE_URL}/api/v1/caregiver/stripe/onboarding-link`,
    loginLink: `${API_BASE_URL}/api/v1/caregiver/stripe/login-link`
  },
  PAYMENTHISTORY: {
    gethistory: `${API_BASE_URL}/api/v1/payment/payments`,
    payToCaregiver: (id) => `${API_BASE_URL}/api/v1/payment/payment-status/${id}`
  },
  SERVICE: {
    list: `${API_BASE_URL}/api/v1/common/services-list`,
    add: `${API_BASE_URL}/api/v1/admin/services`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/services/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/services/${id}`
  },
  NEED: {
    list: `${API_BASE_URL}/api/v1/common/specials-need`,
    add: `${API_BASE_URL}/api/v1/admin/specials-need`,
    edit: (id) => `${API_BASE_URL}/api/v1/admin/specials-need/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/admin/specials-need/${id}`
  },
  APK_API: {
    list: `${API_BASE_URL}/api/v1/mobile-application`,
    add: `${API_BASE_URL}/api/v1/mobile-application`,
    delete: (id) => `${API_BASE_URL}/api/v1/mobile-application/${id}`
  },
  COUNTRIES: {
    list: `${API_BASE_URL}/api/v1/common/countries`,
    add: `${API_BASE_URL}/api/v1/common/countries`,
    edit: (id) => `${API_BASE_URL}/api/v1/common/countries/${id}`,
    delete: (id) => `${API_BASE_URL}/api/v1/common/countries/${id}`
  }
}
